<template>
    <v-autocomplete
            v-model="model"
            :items="items"
            item-text="name"
            item-value="id"
            filled
            hide-details
            :label="label || 'Seleccionar Especialista' + (isMultiple ? 's' : '')"
            :prepend-inner-icon="showIcon ? 'fas fa-user-md' : null"
            return-object
            :multiple="isMultiple"
            :disabled="loading || disabled"
            :required="isRequired"
            @blur="onBlur"
    >

        <template v-slot:item="{item, index}">
            <template v-if="typeof item !== 'object'">
                <v-list-item-content v-text="data"></v-list-item-content>
            </template>
            <template v-else>
                <v-list-item-avatar>
                    <img v-if="item.avatar" :src="item.avatar">
                    <v-icon v-else>fas fa-user-md</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title v-html="item.name"></v-list-item-title>
                    <v-list-item-subtitle v-html="item.services && item.services.map(srv => srv.description).join(',')"></v-list-item-subtitle>
                </v-list-item-content>
            </template>
        </template>

        <template v-if="isMultiple" v-slot:selection="{ item, index }">
            <v-chip small v-if="index === 0">
                <span>{{ item.name }}</span>
            </v-chip>
            <span
                    v-if="index === 1"
                    class="grey--text caption"
            >({{ model.length - 1 }}+)</span>
        </template>

        <template slot="no-data">
               <span class="caption pa-2">No se han encontrado especialistas</span>
        </template>

    </v-autocomplete>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {filterSelectorWithHeaders, filterUniqueIds} from '@/utils/Common'
    import {mapMutations, mapState} from 'vuex'

    export default{
        props: {
         default: {},
          filter:{
            type: Function,
            default: item => item
          },
          showIcon:{
            type: Boolean,
            default: true
          },
          defaultAllSelected: {
            type: Boolean,
            default: false
          },
          autoDefault: {
            type: Boolean,
            default: true
          },
          multiple: {
           type: Boolean,
            default: false
         },
         required:{
           type: Boolean,
           default: false
         },
          service: {
           type: Number
          },
          serviceProviderId: {
           type: Number
          },
          label: {
            type: String,
            default: 'Selecciona especialista'
          },
          disabled: {
            type: Boolean,
            default: false
          },
          value: {
            type: [Object, Array]
          }
        },
        data(){
            return {
                model: this.multiple !== undefined && this.multiple !== false ? [] : null,
                specialists: [],
                loading: false
            }
        },
        watch: {

            specialists(val){
                var vm = this

                if(!vm.autoDefault){
                    vm.syncModelFromValue()
                    return
                }

                const defaultAll =  vm.defaultAllSelected !== undefined && vm.defaultAllSelected !== false
                var defaultValue = defaultAll && vm.isMultiple ? val : (vm.isMultiple ? [vm.defaultSpecialist] : vm.defaultSpecialist)
                vm.model = vm.specialists.length ? defaultValue : (vm.isMultiple ? [] : null)
            },

            service(val){
                this.getSpecialists()
            },

            model(val, oldVal){
                var vm = this
                vm.$emit('change', val)
                if(vm.isRequired && (!val || val.length === 0)) this.model = vm.isMultiple  ? oldVal.slice() : oldVal
            },

            currentBranchOffice(val){
              if(val) this.getSpecialists()
            },

            value(val){
                const vm = this

                if(val){
                    vm.model = val
                    return
                }

                if(!vm.autoDefault) vm.syncModelFromValue()
            }

        },
        async mounted(){
            await this.getSpecialists()
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            clear(){
                this.model = this.isMultiple ? [] : null
            },
            syncModelFromValue(){
                const vm = this
                const value = vm.value

                if(value && (!Array.isArray(value) || value.length > 0)){
                    vm.model = value
                    return
                }

                vm.model = vm.isMultiple ? [] : null
            },
            onBlur(){
                var vm = this
                vm.$emit('blur', JSON.parse(JSON.stringify(vm.model)))
            },
            async getSpecialists(){

                var vm = this
                if(!vm.currentBranchOffice) return

                var filters = {offices : [vm.currentBranchOffice.id]};
                if(vm.service){
                    filters.services = [vm.service]
                }

                var url = `public/provider/${vm.serviceProviderId}/specialists`

                vm.loading = true
                var response = await ApiUtils.makeGet(url, filters)
                vm.loading = false

                if (!response.ok) {
                    vm.showSnackBar('Ha ocurrido un error consultando especialistas')
                    return
                }

                const json = await response.json()

                vm.specialists = json.result.specialists
                vm.$emit('loaded', json.result.specialists)


            }
        },
        computed: {
                ...mapState(['currentBranchOffice', 'currentProvider', 'currentUser']),
            isMultiple(){
                return this.multiple != undefined && this.multiple !== false
            },

            defaultSpecialist(){

                var vm = this
                if(!vm.specialists || vm.specialists.length === 0) return null

                if(vm.value) return vm.value

                if(!vm.currentProvider || !vm.currentProvider.institution || !vm.currentProvider.role){
                    return vm.specialists[0]
                }

                const roleId =  vm.currentProvider.role.id  || vm.currentProvider.role.role.id
                const isSpecialist =  roleId === 3
                if(!isSpecialist){
                    return vm.items[0]
                }

                const me = vm.items.find(specialist => {
                    return specialist.id === vm.currentUser.id
                })

                return me || vm.items[0]

            },

            isRequired(){
              return this.required != undefined && this.required !== false
            },

            items(){

                var vm = this
                var all = []

                if(!vm.specialists.length) return all

                var specialists = vm.specialists

                specialists.forEach((specialist) => {
                    all.push({
                        id: specialist.id,
                        name: specialist.full_name || specialist.email,
                        avatar: specialist.avatar,
                        services: specialist.services
                    })
                })

                return all.filter(vm.filter)

            }
        },
    }
</script>
